import styled, { css } from 'styled-components';
import { baseStyles, baseProps } from './base.style';
import { containerStyles, containerProps } from './container.style';
import { breakpointStyles, getPropTypes } from './utils';

const listStyles = props => {
  if (props.withBorders) {
    return css`
      > li {
        border-bottom: 1px solid
          ${props => props.theme.colors.background.tertiary};

        &:first-child {
          border-top: 1px solid
            ${props => props.theme.colors.background.tertiary};
        }
      }
    `;
  }
};

export const List = styled.ul<StyleProps>`
  ${baseStyles}
  ${containerStyles}
  ${listStyles}

  ${breakpointStyles(baseStyles)}
  ${breakpointStyles(containerStyles)}
  ${breakpointStyles(listStyles)}
`;

export const listProps = {
  ...baseProps,
  ...containerProps,
};

List.propTypes = getPropTypes(listProps);
